module.exports = __webpack_public_path__ + "static/img/70 (1).17d7772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/70 (1).jpg
// module id = jJoh
// module chunks = 0